export class ResultList {

    Id: number;
    Title: string;
    ForeignTitle: string;

    constructor() { }
}